import * as React from "react";
import { motion } from "framer-motion";
import { MenuItem } from "./MenuItem";

import * as styles from "./Menu.module.scss";

const variants = {
  open: {
    x: 0,
    transition: { staggerChildren: 0.07, delayChildren: 0.2 },
  },
  closed: {
    x: "-100vw",
    transition: { staggerChildren: 0.05, staggerDirection: -1 },
  },
};

export const Navigation = ({ items, toggle }) => (
  <motion.ul variants={variants} className={styles.navigation}>
    {items &&
      items.map((item, index) => (
        <MenuItem item={item} key={index} toggle={toggle} />
      ))}
  </motion.ul>
);
